import { AutoPatchStatusEnum } from '@/react/portainer/settings/types';

import { Badge, BadgeType } from '@@/Badge';

export function StatusBadge({ status }: { status: AutoPatchStatusEnum }) {
  let statusType: BadgeType;
  let statusText: string;
  switch (status) {
    case AutoPatchStatusEnum.Completed:
      statusType = 'success' as BadgeType;
      statusText = 'Succeeded';
      break;
    case AutoPatchStatusEnum.Failed:
      statusType = 'danger' as BadgeType;
      statusText = 'Failed';
      break;
    case AutoPatchStatusEnum.InProgress:
    default:
      statusType = 'indigo' as BadgeType;
      statusText = 'In progress';
      break;
  }

  return <Badge type={statusType}>{statusText}</Badge>;
}
